import * as React from 'react';
import Lightbox from 'react-images';
import AppConfig from '../AppConfig';
import Figure from '../Figure';
import { makeImageLink } from '../utils/image';
export default function Galleries({ images, transform = 'w_400,h_300,c_fill', thumbTransform = 'w_40,h_30,c_fill', displayItems = 3, }) {
    const [selected, onChange] = React.useState(0);
    const [isOpen, open] = React.useState(false);
    const remain = images.length - displayItems;
    return (React.createElement(AppConfig, null, ({ imageHost }) => {
        const lightboxImages = images.map(image => {
            return {
                src: makeImageLink({ image, host: imageHost }),
                caption: image.caption,
                alt: image.caption,
            };
        });
        return (React.createElement("div", { className: "flex flex-wrap nl2 nr2 nl3-ns nr3-ns" },
            images.slice(0, displayItems).map((image, idx) => {
                return (React.createElement("div", { key: idx, className: "w-100 w-third-ns pa2 pa3-ns" },
                    React.createElement("a", { className: "ba b--light-gray bg-white relative db pointer", onClick: () => {
                            onChange(idx);
                            open(true);
                        } },
                        idx === displayItems - 1 && remain > 0 && (React.createElement("div", { className: "absolute absolute--fill flex items-center justify-center bg-black-50" },
                            React.createElement("span", { className: "near-white" },
                                remain,
                                "+"))),
                        React.createElement(Figure, { image: {
                                usePlaceholder: !!image.id,
                                ...image,
                                transform,
                                thumbTransform,
                            } }))));
            }),
            React.createElement(Lightbox, { isOpen: isOpen, currentImage: selected, images: lightboxImages, backdropClosesModal: true, onClickPrev: () => 
                // onChange(selected === 0 ? items.length : selected - 1)
                onChange(selected - 1), onClickNext: () => 
                // onChange(selected === items.length ? 0 : selected + 1)
                onChange(selected + 1), onClose: () => open(false) })));
    }));
}
//# sourceMappingURL=index.js.map